module.exports = __webpack_public_path__ + "img/work_outline-24px.76c1960a.svg";